import { render, staticRenderFns } from "./NftPlayground.vue?vue&type=template&id=4cdc4776&"
import script from "./NftPlayground.vue?vue&type=script&lang=js&"
export * from "./NftPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports